import * as React from 'react';

import PropTypes from 'prop-types';

import { CMI5 } from '../../../../const';
import { Selector } from '@netexknowledge/smart-components';

export class GradebookSelect extends React.Component {
  static propTypes = {
    options: PropTypes.array,
    setSelectedItem: PropTypes.func,
    label: PropTypes.string,
    selectedItem: PropTypes.object,
    classroomId: PropTypes.string,
    colors: PropTypes.any,
    sectionId: PropTypes.string
  };

  isAssessable = activity => {
    if (activity && activity.activityType === CMI5.ACTIVITY_TYPE.LESSON) {
      return activity.hasChildren;
    }
    return true;
  };

  handleClickMenuItem = option => {
    const { setSelectedItem, classroomId, sectionId } = this.props;
    if (option && (option.activityId || option.id)) {
      if (!option.activityType) {
        setSelectedItem(classroomId, option, sectionId);
      } else {
        setSelectedItem(option, sectionId);
      }
    } else {
      setSelectedItem();
    }
  };

  getSelectOptions = options => {
    const { label } = this.props;
    const mapped = options.map(item => ({ [item.id]: item.name }));
    return Object.assign({}, { undefined: `${label}` }, ...mapped);
  };

  getOption = key => {
    const { options } = this.props;
    return options.find(({ id }) => id === key);
  };

  setSelectedKey = item => {
    if (item != null) {
      return item.id ? item.id : item.activityId;
    }
    return undefined;
  };

  render() {
    const { colors, options, selectedItem, label } = this.props;
    const disabled = options && options.length === 0;

    return (
      <div className="selector-container">
        <Selector
          disabled={disabled}
          label={label}
          elements={this.getSelectOptions(options.filter(this.isAssessable))}
          onChange={e => this.handleClickMenuItem(this.getOption(e))}
          selectedKey={this.setSelectedKey(selectedItem)}
        />
      </div>
    );
  }
}

export default GradebookSelect;
